import React, { useEffect, useState } from 'react'
import { Swiper, Image } from 'antd-mobile'
import { utils } from '@/utils'
import styles from './Banner.module.less'
import type { ModuleItemProps } from '@/types/interfaces'
import apis from '@/apis'
import { useNavigate } from 'react-router-dom'
import { routesMap } from '@/router/routes'

const { px2rem, to, concatenateImageUrl } = utils
const { corpApi } = apis

interface ModuleProps {
  module: ModuleItemProps
}

interface ModuleDetails {
  [key: string]: any
}

const Banner: React.FC<ModuleProps> = (props) => {
  const { corpId, corpModuleId } = props.module
  const navigate = useNavigate()
  const [detail, setDetail] = useState<ModuleDetails[]>([])
  /*
   * 获取模块详情
   */
  async function getModuleDetail() {
    if (!corpId || !corpModuleId) return

    // 获取详情
    const [err, res] = await to(
      corpApi.queryHomeModuleDetail({ corpId, corpModuleId }),
    )

    if (err || !res.data) return

    // 处理数据
    const detail = res.data.map((item: any) => {
      item.image = concatenateImageUrl(item.image)
      return item
    })

    setDetail(detail)
  }

  /*
   * 点击跳转
   */
  function handleNavigation(index: number) {
    const item = detail[index]

    if (
      !item ||
      !item.detail ||
      !item.detail.dataType ||
      !item.detail.dataValue
    ) {
      return
    }

    const { dataType, dataValue, sort } = item.detail

    // 如果是货品，则跳到货品详情页
    // if (dataType === 6) {
    //   navigate(`/product/detail/${dataValue}`);
    //   return;
    // }

    // 否则跳到 筛选结果
    navigate(
      `${routesMap.MarktingSearch}?dataType=${dataType}&dataValue=${dataValue}&sort=${sort}`,
    )
  }

  useEffect(() => {
    getModuleDetail()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props])

  const items = detail.map((item, index) => (
    <Swiper.Item key={corpModuleId + index}>
      <div
        className={styles['banner-item']}
        onClick={() => {
          handleNavigation(index)
        }}
      >
        <Image
          fit="cover"
          className={styles['preview-img']}
          src={item.image}
          width={'100%'}
          height={'100%'}
          lazy={true}
        />
      </div>
    </Swiper.Item>
  ))

  return (
    <div className={styles['banner-wrap']}>
      <Swiper
        autoplay
        loop
        indicatorProps={{
          color: '#FE5700',
        }}
        style={{
          '--border-radius': px2rem(16),
          '--track-padding': '0 0 14px',
        }}
      >
        {items}
      </Swiper>
    </div>
  )
}

export default Banner
